import * as React from 'react';
import {useEffect, useRef} from 'react';
import {ClickStat} from "../lib/types/types";
import Users from "./administration/users/Users";
import {configureApp} from "../lib/configureApp";
import {useIntl} from "react-intl";

interface Props {
}

interface ButtonInterface {
    name: string;
    id: number;
    description: string
}

const MainScreen: React.FC<Props> = props => {
    const didMountRef = useRef(false);
    const {formatMessage: f} = useIntl();

    configureApp(f);

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);


    return <>
        <Users/>
    </>

};

export default MainScreen
